module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', [_c('el-alert', {
    attrs: {
      "title": "客户信息",
      "type": "success",
      "description": "由于客户数据过于巨大,该列表显示的数据为回调数据,仅仅为部分数据,仅供浏览!.",
      "show-icon": ""
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "mini"
    },
    on: {
      "click": _vm.getSync
    }
  }, [_vm._v("同步数据")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 4
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "切换企业"
    },
    on: {
      "change": _vm.typesearch
    },
    model: {
      value: (_vm.params.corp_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "corp_id", $$v)
      },
      expression: "params.corp_id"
    }
  }, _vm._l((_vm.corpList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "size": "mini",
        "value": item.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.catesList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unionid",
      "label": "unionid"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "avatar",
      "label": "头像"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "right"
          }
        }, [_c('img', {
          staticStyle: {
            "width": "200px",
            "height": "200px"
          },
          attrs: {
            "src": scope.row.avatar,
            "alt": scope.row.name
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('img', {
          staticStyle: {
            "width": "30px",
            "height": "30px"
          },
          attrs: {
            "src": scope.row.avatar,
            "alt": scope.row.name
          }
        })])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "label": "男/女"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.gender == '1') ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("男")]) : _c('el-tag', {
          attrs: {
            "type": "info"
          }
        }, [_vm._v("女")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-30146cb6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30146cb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/workwx/contact.vue
// module id = 2591
// module chunks = 0